import type { Procedure } from '../../../../app-core/lib/procedure/Procedure'
import type { AppUnitType } from '../../../../shared/domain/units/types.no-deps'
import type { Form_IForm } from '../../../zap/Form/Form.types'
import type {
    Type_IActionType,
    Type_ICalendarEvent,
    Type_ILocation,
    Type_ILocationFocusList,
    Type_IReport,
    Type_IUnit,
    Type_IUnitList,
    Type_Workflow,
} from '../../../zap/Type/Type.hive'

export const SYNC_ACTIVITIES = 'SYNC_ACTIVITIES'
export const SYNC_ACTION_TYPES = 'SYNC_ACTION_TYPES'
export const SYNC_CALENDAR_EVENTS = 'SYNC_CALENDAR_EVENTS' as const
export const SYNC_CAMPAIGNS = 'SYNC_CAMPAIGNS'
export const SYNC_FOCUS_LISTS = 'SYNC_FOCUS_LISTS' as const
export const SYNC_FORMS = 'SYNC_FORMS'
export const SYNC_LOCATIONS = 'SYNC_LOCATIONS' as const
export const SYNC_REPORTS = 'SYNC_REPORTS' as const
export const SYNC_UNITS = 'SYNC_UNITS'
export const SYNC_UNIT_TYPES = 'SYNC_UNIT_TYPES'
export const SYNC_UNIT_LISTS = 'SYNC_UNIT_LISTS'
export const SYNC_ALL = 'SYNC_ALL' as const // typescript should infer this type we should figure out why it is not

export const RECEIVE_ACTIVITIES = 'RECEIVE_ACTIVITIES'
export const RECEIVE_ACTION_TYPES = 'RECEIVE_ACTION_TYPES'
export const RECEIVE_CALENDAR_EVENTS = 'RECEIVE_CALENDAR_EVENTS'
export const RECEIVE_CAMPAIGNS = 'RECEIVE_CAMPAIGNS'
export const RECEIVE_FOCUS_LISTS = 'RECEIVE_FOCUS_LISTS'
export const RECEIVE_FORMS = 'RECEIVE_FORMS'
export const RECEIVE_LOCATIONS = 'RECEIVE_LOCATIONS'
export const RECEIVE_REPORTS = 'RECEIVE_REPORTS'
export const RECEIVE_UNITS = 'RECEIVE_UNITS'
export const RECEIVE_UNIT_TYPES = 'RECEIVE_UNIT_TYPES'
export const RECEIVE_UNIT_LISTS = 'RECEIVE_UNIT_LISTS'

export type TEntitiesAction =
    | { type: 'SYNC_ACTIVITIES' }
    | { type: 'SYNC_ACTION_TYPES' }
    | { type: 'SYNC_CALENDAR_EVENTS' }
    | { type: 'SYNC_CAMPAIGNS' }
    | { type: 'SYNC_FOCUS_LISTS' }
    | { type: 'SYNC_FORMS' }
    | { type: 'SYNC_LOCATIONS' }
    | { type: 'SYNC_REPORTS' }
    | { type: 'SYNC_UNITS' }
    | { type: 'SYNC_UNIT_TYPES' }
    | { type: 'SYNC_UNIT_LISTS' }
    | { type: 'SYNC_ALL' }
    | { type: 'RECEIVE_ACTIVITIES'; data: Type_Workflow[] }
    | { type: 'RECEIVE_ACTION_TYPES'; data: Type_IActionType[] }
    | { type: 'RECEIVE_CALENDAR_EVENTS'; data: Type_ICalendarEvent[] }
    | { type: 'RECEIVE_CAMPAIGNS'; data: Procedure[] }
    | { type: 'RECEIVE_FOCUS_LISTS'; data: Type_ILocationFocusList[] }
    | { type: 'RECEIVE_FORMS'; data: Form_IForm[] }
    | { type: 'RECEIVE_LOCATIONS'; data: Type_ILocation[] }
    | { type: 'RECEIVE_REPORTS'; data: Type_IReport[] }
    | { type: 'RECEIVE_UNITS'; data: Type_IUnit[] }
    | { type: 'RECEIVE_UNIT_TYPES'; data: AppUnitType[] }
    | { type: 'RECEIVE_UNIT_LISTS'; data: Type_IUnitList[] }

export const syncCalendarEvents = () => ({ type: SYNC_CALENDAR_EVENTS })
export const syncLocations = () => ({ type: SYNC_LOCATIONS })
export const syncReports = () => ({ type: SYNC_REPORTS })
export const syncAll = () => ({ type: SYNC_ALL })

export function receiveActivities(data: Type_Workflow[]): TEntitiesAction {
    return { type: RECEIVE_ACTIVITIES, data }
}

export function receiveActionTypes(data: Type_IActionType[]): TEntitiesAction {
    return { type: RECEIVE_ACTION_TYPES, data }
}

export function receiveCalendarEvents(data: Type_ICalendarEvent[]): TEntitiesAction {
    return { type: RECEIVE_CALENDAR_EVENTS, data }
}

export function receiveCampaigns(data: Procedure[]): TEntitiesAction {
    return { type: RECEIVE_CAMPAIGNS, data }
}

export function receiveFocusLists(data: Type_ILocationFocusList[]): TEntitiesAction {
    return { type: RECEIVE_FOCUS_LISTS, data }
}

export function receiveForms(data: Form_IForm[]): TEntitiesAction {
    return { type: RECEIVE_FORMS, data }
}

export function receiveLocations(data: Type_ILocation[]): TEntitiesAction {
    return { type: RECEIVE_LOCATIONS, data }
}

export function receiveReports(data: Type_IReport[]): TEntitiesAction {
    return { type: RECEIVE_REPORTS, data }
}

export function receiveUnits(data: Type_IUnit[]): TEntitiesAction {
    return { type: RECEIVE_UNITS, data }
}

export function receiveUnitTypes(data: AppUnitType[]): TEntitiesAction {
    return { type: RECEIVE_UNIT_TYPES, data }
}

export function receiveUnitList(data: Type_IUnitList[]): TEntitiesAction {
    return { type: RECEIVE_UNIT_LISTS, data }
}
